// extracted by mini-css-extract-plugin
export var cartIcon = "_k2-0";
export var cartIconContainer = "_k2-1";